import Axios from "axios";
import {
  PRODUCT_CREATE_REVIEW_FAIL,
  PRODUCT_CREATE_REVIEW_REQUEST,
  PRODUCT_CREATE_REVIEW_SUCCESS,
  PRODUCT_DELETE_REVIEW_FAIL,
  PRODUCT_DELETE_REVIEW_REQUEST,
  PRODUCT_DELETE_REVIEW_SUCCESS,
  PRODUCT_DETAILS_REVIEW_FAIL,
  PRODUCT_DETAILS_REVIEW_REQUEST,
  PRODUCT_DETAILS_REVIEW_SUCCESS,
  PRODUCT_EDIT_REVIEW_FAIL,
  PRODUCT_EDIT_REVIEW_REQUEST,
  PRODUCT_EDIT_REVIEW_SUCCESS,
  PRODUCT_LIST_REVIEW_FAIL,
  PRODUCT_LIST_REVIEW_REQUEST,
  PRODUCT_LIST_REVIEW_SUCCESS,
  REFUND_IMAGE_REVIEW_FAIL,
  REFUND_IMAGE_REVIEW_REQUEST,
  REFUND_IMAGE_REVIEW_SUCCESS,
} from "../constants/reviewConstants";

//POST A REQUEST TO CREATE REVIEW IN OrderHistoryScreen
export const actionProductToCreateReview =
  (reviewDetails) => async (dispatch, getState) => {
    dispatch({ type: PRODUCT_CREATE_REVIEW_REQUEST });
    const {
      authenticateUser: { authenticatedUser },
    } = getState();
    try {
      const { data } = await Axios.post(
        `/api/productreviews/reviews`,
        reviewDetails,
        {
          headers: { Authorization: `Bearer ${authenticatedUser?.token}` },
        }
      );
      dispatch({ type: PRODUCT_CREATE_REVIEW_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: PRODUCT_CREATE_REVIEW_FAIL, payload: message });
    }
  };

//GET REQUEST TO BRING SINGLE REVIEW DETAILS IN ModalReviewEditForm
export const actionProductToGetReviewDetails =
  (productId, itemId, orderId) => async (dispatch, getState) => {
    dispatch({ type: PRODUCT_DETAILS_REVIEW_REQUEST });
    const {
      authenticateUser: { authenticatedUser },
    } = getState();
    try {
      const { data } = await Axios.get(
        `/api/productreviews/detailsreview/${productId}/${itemId}/${orderId}`,
        {
          headers: { Authorization: `Bearer ${authenticatedUser?.token}` },
        }
      );
      dispatch({ type: PRODUCT_DETAILS_REVIEW_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: PRODUCT_DETAILS_REVIEW_FAIL, payload: message });
    }
  };

//PUT
//EDIT REVIEW
export const actionProductToEditReview =
  (reviewDetails) => async (dispatch, getState) => {
    dispatch({ type: PRODUCT_EDIT_REVIEW_REQUEST });
    const {
      authenticateUser: { authenticatedUser },
    } = getState();
    try {
      const { data } = await Axios.put(
        `/api/productreviews/editreview`,
        reviewDetails,
        {
          headers: { Authorization: `Bearer ${authenticatedUser?.token}` },
        }
      );
      dispatch({ type: PRODUCT_EDIT_REVIEW_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: PRODUCT_EDIT_REVIEW_FAIL, payload: message });
    }
  };

//DELETE
//DELETE REVIEW
export const actionProductToDeleteReview =
  (productId, itemId, orderId, reviewId) => async (dispatch, getState) => {
    dispatch({ type: PRODUCT_DELETE_REVIEW_REQUEST });
    const {
      authenticateUser: { authenticatedUser },
    } = getState();
    try {
      const { data } = await Axios.delete(
        `/api/productreviews/reviewdelete/${productId}/${itemId}/${orderId}/${reviewId}`,
        {
          headers: { Authorization: `Bearer ${authenticatedUser?.token}` },
        }
      );
      dispatch({ type: PRODUCT_DELETE_REVIEW_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: PRODUCT_DELETE_REVIEW_FAIL, payload: message });
    }
  };

//GET REVIEWS LIST
export const actionToGetReviewsList =
  (productId, rating, count) => async (dispatch) => {
    try {
      dispatch({ type: PRODUCT_LIST_REVIEW_REQUEST });
      const { data } = await Axios.get(
        `/api/productreviews/listreview/${productId}/${rating}/${count}` // There are optional parameters rating and count
      );
      dispatch({ type: PRODUCT_LIST_REVIEW_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: PRODUCT_LIST_REVIEW_FAIL, payload: message });
    }
  };

//POST A REQUEST TO REFUND FOR IMAGE REVIEW
export const actionToRefundForImageReview =
  (refundImageReviewDetails) => async (dispatch, getState) => {
    dispatch({ type: REFUND_IMAGE_REVIEW_REQUEST });
    const {
      authenticateUser: { authenticatedUser },
    } = getState();
    try {
      const { data } = await Axios.post(
        `/api/productreviews/refundimagereview`,
        refundImageReviewDetails,
        {
          headers: { Authorization: `Bearer ${authenticatedUser?.token}` },
        }
      );
      dispatch({ type: REFUND_IMAGE_REVIEW_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: REFUND_IMAGE_REVIEW_FAIL, payload: message });
    }
  };
